import { ConfirmationModal } from "@platform/design-system";

interface PostSubmitNotificationsProps {
  showMetlifeModal: boolean;
  onClose: () => void;
}

/**
 * Component to display post-submit notifications for final decisions.
 * Currently handles MetLife SCA form notification modal.
 */
export const PostSubmitNotifications = ({
  showMetlifeModal,
  onClose,
}: PostSubmitNotificationsProps): React.JSX.Element => (
  <ConfirmationModal
    open={showMetlifeModal}
    title="Metlife SCA Form Required"
    description="This case includes 500+ eligible lives and will generate new business with MetLife on at least one line of coverage. Once the final sold decision details are submitted, please request the SCA form from MetLife and have it sent to Taylor Bennett for processing. The SCA is required to ensure Centro receives revenue."
    confirmButtonText="Acknowledge"
    cancelButtonText=""
    onAccept={onClose}
    onCancel={onClose}
  />
);
